// text-align is not working on safari so we are adding custom label for displaying selected value

document.addEventListener('turbolinks:load', () => {
  $('.js-input-v2').trigger('change');
});

$(document).on('change', '.js-input-v2', ({ target }) => {
  target.previousSibling.querySelector('.input-value-clone').innerHTML = target.options[target.selectedIndex].text;
});
